/* eslint-disable import/no-cycle */
import {Col, Row} from 'antd';
import {observer} from 'mobx-react-lite';
import {chunk} from 'lodash';
import Empty from '../empty/Empty';
import ModelProperties from './ModelProperties';

const ModelPropertyGroups = ({column = 1, groups, model, hideEmpty = true}) => {
  if (!groups || !groups.length || !model) {
    return <Empty/>;
  }

  const rows = chunk(groups, column);

  return (
    <>
      {rows.map((rowGroups, rowIndex) => (
        <Row key={`row-${rowIndex.toString()}`} gutter={[16, 16]} wrap={false} style={{marginBottom: 16}}>
          {rowGroups.map((group, index) => (
            <Col key={`group-${index.toString()}`} flex={1} style={{flexBasis: 0}}>
              <ModelProperties
                title={group.showGroupLabel ? group.title : undefined}
                column={group.columnCount}
                showPropertyLabels={group.showPropertyLabels}
                properties={group.properties}
                model={model}
                hideEmpty={hideEmpty}
              />
            </Col>
          ))}
        </Row>
      ))}
    </>
  );
};

export default observer(ModelPropertyGroups);
